// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"parse-link_linkWrapper__xw0qM","docReader":"parse-link_docReader__CYU2w","link":"parse-link_link__53oTO"};